import React, { useState, useContext, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { CusButton } from "../../Components/From/Button";
import { AsyncModel, AsyncModelClose } from "../AsyncModel/AsyncModel";

// import { CusInput } from '../../Components/From/Input';
import { FormattedMessage } from "react-intl";
import { Global } from "../../App";
// import Tool_dropDown from '../../Components/Tools/Tool_dropDown';
// switch lang
import { langStringToCode } from "../../Share/Tools/switchLang";
// api
import { getAllCountry, getSpecificCountry } from "../../Api/GetCountry";
import Tool_storeName from "../Tools/Tool_storeName";
import moment from "moment";
/**
 *
 * @param {object} props
 *
 * 本次步驟會影響的global state
 * country
 * currentStep (2 ± 1)
 */

function OrderStep_2(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, setState] = useState({
    countryList: [],
    countrySelected: {
      country: null,
      countryName: null,
    },
  });
  // 取得所有國家
  async function apiAllCountry(langId) {
    try {
      const res = await getAllCountry(langId);
      const { errCode, countryList } = res.data;
      if (errCode == 200) {
        const newCountryList = countryList.map((e) => ({
          title: e.name,
          value: e.id,
        }));

        return newCountryList;
      } else {
        dispatchGlobal({
          type: "UPDATE",
          payload: [{ key: "errMsg", val: errCode }],
        });

        props.history.push("/error");
      }
    } catch (err) {
      console.error("AllCountry error.");
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 406 }],
      });

      props.history.push("/error");
    }
  }
  // 取得指定的國家
  async function apiSpecificCountry(requireData) {
    try {
      const res = await getSpecificCountry(requireData);
      const { errCode, country } = res.data;
      if (errCode == 200) {
        const newSelectedCountry = {
          title: country.name,
          value: country.id,
        };

        return newSelectedCountry;
      } else {
        dispatchGlobal({
          type: "UPDATE",
          payload: [{ key: "errMsg", val: errCode }],
        });

        props.history.push("/error");
      }
    } catch (err) {
      console.error("SpecificCountry error.");
    }
  }

  // get api
  useEffect(() => {
    const langCode = langStringToCode(globalState.langType);
    const countryCode = globalState.customer.orderInfo.country;
    const branchName = globalState.customer.orderInfo.selectedBranch.branchName;
    if (branchName.includes("高雄")) {
      AsyncModel({
        content: (
          <div
            className="w-100 d-flex"
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap:"20px"
            }}
          >
            <span className="icn ic_close" onClick={AsyncModelClose} style={{position:"absolute",top:"-15px",right:"-15px",cursor:"pointer"}}></span>
            <img style={{ width: "100%", maxWidth: "450px" }} src={"https://appnotice.dintaifung.com.tw/upload/thumbs/Kpopup.jpg"} />
            {/* <div
              onClick={AsyncModelClose}
              style={{
                padding: "10px 55px",
                backgroundColor: "#d84e40",
                color: "white",
                borderRadius: "5px",
                cursor: "pointer",
                display: "inline-block",
              }}
            >
              確認
            </div> */}
          </div>
        ),
        showConfirmBtn: false,
      });
    }
    const updateCountryList = async () => {
      let countryList = await apiAllCountry(langCode);
      let selectedCountry = await apiSpecificCountry({
        languageID: langCode,
        countryID: countryCode,
      });
      if (countryList && selectedCountry) {
        setState((curr) => {
          let newState = { ...curr };
          newState.countryList = countryList;
          newState.countrySelected = {
            country: selectedCountry.value,
            countryName: selectedCountry.title,
          };

          return newState;
        });
      }
    };

    updateCountryList();
  }, [globalState.langType]);

  // 更新globalState country
  useEffect(() => {
    const { country, countryName } = state.countrySelected;
    dispatchGlobal({
      type: "UPDATE",
      payload: [
        {
          key: "customer",
          val: {
            ...globalState.customer,
            orderInfo: {
              ...globalState.customer.orderInfo,
              country: country ? country : null,
              countryName: countryName ? countryName : null,
            },
          },
        },
      ],
    });
  }, [state.countrySelected]);

  function showForm() {
    let pcStyle = globalState.device === "pc";
    return (
      <div className="d-flex col flex-column justify-content-center align-items-center p-0">
        <div
          className="d-flex flex-column pt-4 pb-4"
          style={{
            minWidth: pcStyle ? "500px" : "100%",
            maxWidth: pcStyle ? "500px" : "100%",
          }}
        >
          <div className="mb-4">
            <div className="w-100">
              <FormattedMessage id="pages.takeOrder.step2.queueNumber" />
              <div className="d-flex w-100">
                <div className="CusText pt-2">
                  {globalState.customer.orderInfo.queueNumber}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="w-100">
              <FormattedMessage id="pages.takeOrder.step2.numberOfTitle" />
              <div className="d-flex w-100">
                <div className="CusText pt-2">
                  {globalState.customer.orderInfo.numberOfAdult}
                </div>
                <div className="CusText pt-2 pl-2">
                  <FormattedMessage id="pages.takeOrder.step2.numberOfAdult" />
                </div>
                <div className="CusText pt-2 pl-2">
                  {globalState.customer.orderInfo.numberOfChild}
                </div>
                <div className="CusText pt-2 pl-2">
                  <FormattedMessage id="pages.takeOrder.step2.numberOfChild" />
                </div>
              </div>
            </div>
            {/* <div className="d-flex w-100">
              <div className="d-flex col-3 p-0">
                <CusInput
                  className="w-100 text-center"
                  readonly
                  value={globalState.customer.orderInfo.numberOfAdult}
                  onChange={() => { }}
                />
                <span className="text-nowrap d-flex align-items-center mr-2 ml-2">
                  <FormattedMessage id="pages.takeOrder.step2.numberOfAdult" />
                </span>
              </div>
              <div className="d-flex col-3 p-0">
                <CusInput
                  className="w-100 text-center"
                  readonly
                  value={globalState.customer.orderInfo.numberOfChild}
                  onChange={() => { }}
                />
                <span className="text-nowrap d-flex align-items-center mr-2 ml-2">
                  <FormattedMessage id="pages.takeOrder.step2.numberOfChild" />
                </span>
              </div>
            </div> */}
            {/* <div className="w-100 text-danger mt-2 mb-2">
              <FormattedMessage id="pages.takeOrder.step2.numberModifyNote" />
            </div> */}
          </div>
          {/*<div className="mt-4 mb-4">
            <div className="w-100">
              <FormattedMessage id="pages.takeOrder.step2.countryOfbranch" />
              <div className="d-flex w-100">
                <div className="CusText pt-2">
                  {state.countrySelected.countryName}
                </div>
              </div>
            </div>
            {/* <Tool_dropDown
              items={state.countryList}
              selected={state.countrySelected.country}
              onSelected={e => {
                setState(curr => {
                  let newState = { ...curr };
                  newState.countrySelected = {
                    country: e.value,
                    countryName: e.title
                  };
                  return newState;
                });
              }}
            /> 
          </div>*/}
          <div className="mt-3 bgColorBrown-10 text-black p-3">
            <FormattedMessage id="pages.takeOrder.step2.allergen" />
          </div>
          <div className="mt-4 mb-4 d-flex">
            {/* 返回 */}
            <CusButton.White
              className="mt-2 mb-2 mr-3 col p-3 order-step2-back"
              children={
                <FormattedMessage id="pages.takeOrder.step2.buttonBack" />
              }
              onClick={() => {
                dispatchGlobal({
                  type: "UPDATE",
                  payload: [
                    {
                      key: "customer",
                      val: {
                        ...globalState.customer,
                        currentStep: "1",
                        orderInfo: {
                          ...globalState.customer.orderInfo,
                          country: "",
                          queueNumber: "",
                          queueCode: "",
                          numberOfAdult: "",
                          numberOfChild: "",
                          orderTime: "",
                        },
                      },
                    },
                  ],
                });
              }}
            />
            {/* 確認 */}
            <CusButton.Red
              className="mt-2 mb-2 ml-3 col p-3 order-step2-confirm"
              children={
                <FormattedMessage id="pages.takeOrder.step2.buttonConfirm" />
              }
              onClick={() => {
                dispatchGlobal({
                  type: "UPDATE",
                  payload: [
                    {
                      key: "customer",
                      val: {
                        ...globalState.customer,
                        orderInfo: {
                          ...globalState.customer.orderInfo,
                          orderTime: moment().format("YYYY/MM/DD HH:mm:ss"),
                        },
                        currentStep: "3",
                      },
                    },
                  ],
                });
              }}
            />
          </div>
        </div>
      </div>
    );
  }
  // 接收到countryList資料之前 不渲染畫面
  if (
    !state.countryList ||
    (Array.isArray(state.countryList) && state.countryList.length <= 0)
  ) {
    return null;
  }

  return (
    <>
      <div className="Pages__action d-flex justify-content-center align-items-center pt-3 pb-3 mt-sm-3 mb-sm-3">
        <Tool_storeName
          storeId={globalState.customer.orderInfo.selectedBranch.branchCode}
        />
        {/* {globalState.customer.orderInfo.selectedBranch.branchCode} */}
      </div>
      {showForm()}
    </>
  );
}

export default withRouter(OrderStep_2);
